













































import { Component, Prop, Vue } from 'vue-property-decorator';

import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';
import { IProjectMetadata } from '@/interfaces/report';

import { agencyStore, projectStore } from '@/store/store';

import NewAsphaltScenarioInfo from '@/modules/design/views/asphalt/1-AsphaltScenarioInfo.vue';
import NewAsphaltDesignParameters from '@/modules/design/views/asphalt/2-AsphaltDesignParameters.vue';
import { UnitSystem } from '@/interfaces/units';


@Component({
  components: {
    ProjectBreadcrumb,
    ScenarioInfo: NewAsphaltScenarioInfo,
    DesignParameters: NewAsphaltDesignParameters,
  },
})
export default class AgencyCostScenarioContainerB extends Vue {
  @Prop() pages!: { link: string, text: string }[];

  @Prop() pxModuleId!: number;

  get scenario() {
    return agencyStore.currentScenario;
  }

  currentProjectMetadata: IProjectMetadata | null = null;

  mounted() {
    agencyStore.loadCurrentScenario(this.pxModuleId).then((scenario) => {
      agencyStore.setCurrentScenario(scenario);
      projectStore.getProjectMetadata(scenario.project).then((meta) => this.currentProjectMetadata = meta);
    });
  }

  public displayImperial: boolean = true;

  get currentUnitSystemIsImperial() {
    return agencyStore.displayUnits === UnitSystem.Imperial;
  }

  saveUnitSelection() {
    if (this.currentUnitSystemIsImperial) {
      agencyStore.setDisplayUnits(UnitSystem.Metric);
    } else {
      agencyStore.setDisplayUnits(UnitSystem.Imperial);
    }
    console.log(agencyStore.displayUnits);
  }
}
